//
// Model PaymentGroup

import LocalStorageModel from "../prototypes/LocalStorageModel";
import PaymentModeCollection from "./PaymentModeCollection";
import { app } from "@src/backbone/model/AppModel";
import PaymentModeModel from "./PaymentModeModel";
//
const VAD = "vad",
  VAE = "vae";

export enum PaymentGroupLocation {
  DEFAULT = 0,
  TITRES_RESTAURANT = 1,
}

class PaymentGroupModel extends LocalStorageModel {
  name = "PaymentGroupModel";
  route = "apiPaymentGroupModel";
  idAttribute = "id_payment_group";
  payment_modes: PaymentModeCollection = new PaymentModeCollection();
  id_store: string | undefined;
  isSetup: boolean = false;

  defaults() {
    return {
      vae: false,
      vad: false,
      payment_modes: [],
      location: PaymentGroupLocation.DEFAULT,
    };
  }

  initialize(attributes?: any, options?: any): void {
    // ObjectModel constructor heritage
    super.initialize.apply(this, [attributes, options]);
    //
    this.payment_modes = new PaymentModeCollection();
  }

  setup() {
    const model = this;
    model.get("payment_modes")?.forEach(function (id_payment_mode: string) {
      const paymentMode = app.getPaymentMode(id_payment_mode);
      paymentMode && model.addPaymentMode(paymentMode);
    });
    model.isSetup = true;
  }

  addPaymentMode(paymentMode: PaymentModeModel) {
    const model = this,
      isVae = model.get(VAE),
      isVad = model.get(VAD),
      pmVae = paymentMode.get(VAE),
      pmVad = paymentMode.get(VAD);
    model.set(VAE, isVae || pmVae);
    model.set(VAD, isVad || pmVad);
    model.payment_modes.add(paymentMode);
  }

  isAvailable(vad: boolean) {
    return this.get(vad ? VAD : VAE);
  }

  getPaymentModes(): PaymentModeCollection {
    if (!this.isSetup) {
      this.setup();
    }
    return this.payment_modes;
  }

  getPaymentMode(id_payment_mode: string): PaymentModeModel | undefined {
    if (!this.isSetup) {
      this.setup();
    }
    return this.payment_modes.get(id_payment_mode + "");
  }

  getLocation() {
    return this.get("location") as PaymentGroupLocation;
  }
}

PaymentGroupModel.prototype.name = "PaymentGroupModel";
PaymentGroupModel.prototype.route = "apiPaymentGroupModel";
PaymentGroupModel.prototype.idAttribute = "id_payment_group";
export default PaymentGroupModel;
